const aboutusCntnt = (() => {
  if (document.querySelector("body#pageAboutus") !== null) {



    let secCntnt = document.querySelector('#jsSecCntnt');
    let cntntWraps = secCntnt.querySelectorAll('.js-cntnt-wrap');


    cntntWraps.forEach((element, index) => {

      let imgArea = element.querySelector('.js-img-area');
      let imgBoxInner = element.querySelector('.js-img-box-inner');
      let copyArea = element.querySelector('.js-copy-area');

      let tl1 = gsap.timeline({
        scrollTrigger: {
          invalidateOnRefresh: true,
          trigger: imgArea,
          endTrigger: secCntnt,
          start: "0% 0%",
          end: "100% 100%",
          onEnter: () => imgArea.classList.add('is-act'),
          // onLeave: () => console.log("onLeave"),
          // onEnterBack: () => console.log("onEnterBack"),
          onLeaveBack: () => imgArea.classList.remove('is-act'),
          pin: true,
          pinSpacing: false,
          // markers: true,
        },
      })
      let tl2 = gsap.timeline({
        scrollTrigger: {
          invalidateOnRefresh: true,
          trigger: imgArea,
          // endTrigger: secCntnt,
          start: "0% 100%",
          // end: "100% 100%",
          onEnter: () => imgBoxInner.classList.add('is-act'),
          // onLeave: () => console.log("onLeave"),
          // onEnterBack: () => console.log("onEnterBack"),
          onLeaveBack: () => imgBoxInner.classList.remove('is-act'),
          // markers: true,
        },
      })
      let tl3 = gsap.timeline({
        scrollTrigger: {
          invalidateOnRefresh: true,
          trigger: copyArea,
          // endTrigger: secCntnt,
          start: "0% 80%",
          end: "0% 10%",
          onEnter: () => copyArea.classList.add('is-act'),
          onLeave: () => copyArea.classList.remove('is-act'),
          onEnterBack: () => copyArea.classList.add('is-act'),
          onLeaveBack: () => copyArea.classList.remove('is-act'),
          // markers: true,
        },
      })

      let target = document.querySelector('body');
      let observer = new ResizeObserver((entries) => {
        entries.forEach((entry) => {
          tl1.scrollTrigger.refresh()
          tl2.scrollTrigger.refresh()
          tl3.scrollTrigger.refresh()
        });
      });
      observer.observe(target);
    });




  }
})()
export default aboutusCntnt;